import React from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import style from './InformationOfRegistration.module.scss';
import RegistrationInfoResult from '../../blocks/RegistrationInfoResult';
import InformationOfRegistrationInfo from '../../blocks/PageInfo/RegistrtionInfo';
import RegistrationHistorySearch from '../../blocks/Search/registrationSearch';
import { IState } from '../../../types/interfaces';
import { Works } from '../../blocks/Works';

const InformationOfRegistration: React.FC = ({ isLoading }: any) => (
  <>
    <div className={style.container}>
      <InformationOfRegistrationInfo />
      <RegistrationHistorySearch />
    </div>
    {isLoading ? (
      <div className={style.spin}>
        <Spin />
      </div>
    ) : (
      <RegistrationInfoResult />
    )}
    <Works />
  </>
);

const mapStateToProps = (state: IState) => ({
  isLoading: state.etpRegistration.isLoading,
});

export default connect(mapStateToProps)(InformationOfRegistration);
